import React from 'react';

const Page404 = () => (
  <>
  </>
);

export default Page404;
